import axiosInstance from "../../lib/axiosInstance"

export const listSubscriptions = async (userId) => {
  const response = await axiosInstance.get("/list_subscriptions", {
    params: { user_id: userId },
  });
  return response?.data;
};

export const listServices = async () => {
  const response = await axiosInstance.get("/list_services");
  return response?.data;
};
